import {deserialize} from "serializr";
import firebase from "firebase";
import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";
import {ConfigBackendModel} from "@/modules/mconfigs/models/ConfigBackendModel";
import {ConfigBackendUtils} from "@/modules/mconfigs/database/ConfigBackendUtils";

export default {
    namespaced: true,
    state: {
         mConfigs: [],
    },
    getters: {
        getConfigs: state => {
            return state.mConfigs;
        },
    },
    mutations: {
        setConfigs(state, values) {
            state.mConfigs = values;
        },
        updateConfig(state, value) {
            let index = state.mConfigs.findIndex(v => {
                return v.uid === value.uid;
            });

            if (index >= 0) {
                state.mConfigs.splice(index, 1, value);
            } else {
                state.mConfigs.push(value);
            }
        },
        deleteConfig(state, name) {
            let index = state.mConfigs.findIndex(v => {
                return v.name === name;
            });

            if (index >= 0) {
                state.mConfigs.splice(index, 1);
            }
        },
        deleteConfigs(state, values) {
            const toRemove = new Set(values.map(v => v.name));
            for (let i = state.mConfigs.length - 1; i >= 0; i--) {
                if (toRemove.has(state.mConfigs[i].name)) {
                    state.mConfigs.splice(i, 1);
                }
            }
        },
    },
    actions: {
        init({/*commit*/}) {
            console.info('backend-store initialized.');
            return ConfigBackendUtils.fetchConfigs()
        },
        fetchConfigs({commit}){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getConfigs', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                    .then((data)=>{
                                        throw data
                                    })
                                    .catch((error) => {
                                        throw error
                                    })
                                }else{
                                    return data.text()
                                    .then((data)=>{
                                        //console.log(JSON.parse(data))
                                        let values = JSON.parse(data).map(v => deserialize(ConfigBackendModel, v));
                                        commit("setConfigs", values);
                                    })
                                    .catch((error) => {
                                        throw error
                                    })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        deployConfig({/*commit*/}, data){
            let config_uid = data.uid
            //console.log('deployConfig:', JSON.stringify(data.value))
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                    let requestOptions = {
                        method: "POST",
                        headers: { "Content-Type": "application/json", 'Authorization': token},
                        body: JSON.stringify(data.value)
                    };
                    return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'uploadConfig', requestOptions)
                        .then(async data => {
                            if (data.status != 200) {
                                return data.text()
                                .then((data)=>{
                                    throw data
                                })
                                .catch((error) => {
                                    throw error
                                })
                            }else{
                                return data.text()
                                .then((fileName)=>{
                                    let releaseConfigs = ConfigStoreUtils.getReleaseConfigs().filter(e=>e.uid == config_uid).clone()
                                    if (releaseConfigs.length != 0){
                                        let first = releaseConfigs[0]
                                        first.deployed = true
                                        ConfigStoreUtils.updateReleaseConfig(first, null)
                                            .then(() => {
                                                return ConfigBackendUtils.fetchConfigs()
                                            })
                                            .catch((error) => {
                                                throw error
                                            })
                                    }else{
                                        return ConfigBackendUtils.fetchConfigs()
                                    }
                                    return "c_" + fileName
                                })
                                .catch((error) => {
                                    return error
                                })
                            }
                        })
                        .catch((error) => {
                            throw error
                        })
                })
            ])
        },
        deleteConfig({commit}, value){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "DELETE",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'removeConfig/' + value.name, requestOptions)
                            .then(async data => {
                                if (data.status !== 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    commit("deleteConfig", value.name);
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        deleteConfigs({commit}, values){
            const deletedValues = [];
            let deletePromises = values.map((value) => {
                return firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "DELETE",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'removeConfig/' + value.name, requestOptions)
                            .then(async data => {
                                if (data.status !== 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                } else {
                                    deletedValues.push(value);
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            });
            return Promise.all(deletePromises).then(() => {
              commit("deleteConfigs", deletedValues);
            });
        },
        setConfigAudience({/*commit*/}, value){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(value)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'setConfigAudience', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                    .then((data)=>{
                                        throw data
                                    })
                                    .catch((error) => {
                                        throw error
                                    })
                                }else{
                                    return ConfigBackendUtils.fetchConfigs()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        setConfigClientVersion({/*commit*/}, value){ // 52
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(value)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'setConfigClientVersion', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return ConfigBackendUtils.fetchConfigs()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        setConfigMaster({/*commit*/}, value){ // 52
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(value)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'setConfigMaster', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return ConfigBackendUtils.fetchConfigs()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        setConfigInfo({/*commit*/}, value){ // 51
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(value)
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'setConfigInfo', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return ConfigBackendUtils.fetchConfigs()
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        getConfigContent({/*commit*/}, configName){ //53
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getConfigContent/' + configName, requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    return data.text()
                                        .then((data)=>{
                                            return JSON.parse(data)
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
    }
}

